import React, {
    forwardRef,
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from 'react'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Snackbar from '@mui/joy/Snackbar'
import { TemplateLibraryList } from './TemplateLibraryList'
import { Loading } from './ui/Loading'
import { v4 as uuidv4 } from 'uuid'
import { TemplateAPI } from '../api/TemplateAPI'
import { TemplateModal } from './TemplateModal'
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined'

export const TemplateLibrary = ({
    maxItems,
    onSubmit,
    templateType = 'blog',
}) => {
    useEffect(() => {
        if (templateType === 'blog') {
            TemplateAPI.getBlogTemplates().then((response) => {
                setTemplates(response.data)
                setIsLoading(false)
            })
        }
        if (templateType === 'product') {
            TemplateAPI.getListingTemplates().then((response) => {
                setTemplates(response.data)
                setIsLoading(false)
            })
        }
    }, [])

    const [isLoading, setIsLoading] = useState(true)
    const [templates, setTemplates] = useState([])
    const [selected, setSelected] = useState({})
    const [isSnackOpen, setIsSnackOpen] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalTemplate, setModalTemplate] = useState(null)
    const [errMsg, setErrMsg] = useState(null)

    const submitTemplates = () => {
        let arr = Object.values(selected)
        if (arr.length == 0) {
            setErrMsg(`Please select at least 1 template`)
            setIsSnackOpen(true)
            return
        }

        onSubmit(arr)
    }

    const toggleSelected = (template) => {
        if (template.id in selected) {
            delete selected[template.id]
            setSelected({ ...selected })
            return
        }

        if (Object.keys(selected).length == maxItems) {
            setErrMsg(`You can only choose up to ${maxItems} templates`)
            setIsSnackOpen(true)
            return
        }

        setSelected({ ...selected, [template.id]: template })
    }

    const closeModal = () => {
        setIsModalOpen(false)
    }

    const handleToggle = (template) => {
        toggleSelected(template)
        closeModal()
    }

    const handleItemClick = (template) => {
        setModalTemplate(template)
        setIsModalOpen(true)
    }

    if (isLoading) {
        return <Loading />
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                p: 2,
                backgroundColor: 'white',
                height: '100%',
                gap: 2,
            }}
        >
            <Box sx={{ alignSelf: 'flex-end' }}>
                <Button
                    onClick={submitTemplates}
                    variant="solid"
                    color="primary"
                    endDecorator={<ChevronRightOutlined />}
                >
                    Submit
                </Button>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: 2,
                    overflow: 'auto',
                }}
            >
                <TemplateLibraryList
                    templates={templates}
                    selected={selected}
                    onItemSelected={toggleSelected}
                    onItemClick={handleItemClick}
                />
            </Box>
            <Snackbar
                variant="solid"
                color="danger"
                autoHideDuration={3000}
                onClose={() => setIsSnackOpen(false)}
                open={isSnackOpen}
            >
                {errMsg}
            </Snackbar>
            {modalTemplate && (
                <TemplateModal
                    isOpen={isModalOpen}
                    template={modalTemplate}
                    isSelected={modalTemplate.id in selected}
                    onClose={closeModal}
                    onToggle={handleToggle}
                />
            )}
        </Box>
    )
}
